import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";

import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";

import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { useHistory } from "react-router-dom";
import "../../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import Loader from "../../common/loader/Loader";
import "./WebConfigurationColumnHead.css";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function WebList(props) {
  const [webColumns, setWebColumns] = useState();
  const [schema, setSchema] = useState();
  const [record, setRecord] = useState();
  const [currency, setCurrencies] = useState();
  const [book, setBooks] = useState();
  const [grouping, setGrouping] = useState();
  const [lineType, setLineType] = useState();
  const [agentPerHead, setAgentPerHead] = useState();
  const [language, setLanguage] = useState();
  const [redirect, setRedirect] = useState(null);
  const [showInfo, setshowInfo] = useState(true);
  const [renderShowsTotal, setrenderShowsTotal] = useState(true);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [value, setValue] = React.useState(0);
  const [selectedIdAgent, setSelectedIdAgent] = React.useState(0);
  const [selectedIdCurrency, setSelectedIdCurrency] = React.useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const [selectedIdWeb, setSelectedIdWeb] = useState(props.initialValue);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  let history = useHistory();
  const useStyles = makeStyles({
    root: {
      width: "100%",
      overflowX: "auto",
    },
    table: {
      minWidth: 230,
    },
    tableHead: {
      background: "#3f51b5",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "darkcyan !important",
      },
    },

    tableRow: {
      "&:hover": {
        backgroundColor: "lightgrey !important",
      },
    },
    headerCell: {
      color: "white",
    },
  });

  const classes = useStyles();

  useEffect(() => {
    GetColumn();
  }, []);

  const GetColumn = () => {
    //Change for server api address
    setIsLoading(true);
    //Web Props',props )
    console.log("WEBROW");
    const url =
      process.env.REACT_APP_API2_URL + "/WebConfigurator/WebColumn_GetList";

    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        setRecord(data[0]);
        setWebColumns(data);

        setIsLoading(false);
      });
  };

  function customConfirm(next, dropRowKeys) {
    const dropRowKeysStr = dropRowKeys.join(",");
    if (
      window.confirm(
        `(It's a custom confirm)Are you sure you want to delete ${dropRowKeysStr}?`
      )
    ) {
      // If the confirmation is true, call the function that
      // continues the deletion of the record.
      next();
    }
  }

  function selectedValues(row) {
    console.log(`You click row id: ${row.idColumn}`);

    props.loadWebColumn(row);
  }

  const options = {
    page: 1, // which page you want to show as default
    sizePerPageList: [
      {
        text: "15",
        value: 15,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ], // you can change the dropdown list for size per page
    sizePerPage: 28, // which size per page you want to locate as default
    pageStartIndex: 1, // where to start counting the pages
    paginationSize: 1, // the pagination bar size.
    prePage: "<", // Previous page button text
    nextPage: ">", // Next page button text
    firstPage: "First", // First page button text
    lastPage: "Last", // Last page button text
    paginationShowsTotal: renderShowsTotal, // Accept bool or function
    paginationPosition: "bottom", // default is bottom, top and both is all available
    // hideSizePerPage: true > You can hide the dropdown for sizePerPage
    // alwaysShowAllBtns: true // Always show next and previous button
    withFirstAndLast: false, // > Hide the going to First and Last page button
    //expandRowBgColor: 'rgb(196, 222, 222)',
    afterDeleteRow: onAfterDeleteRow, // A hook for after droping rows.
    //handleConfirmDeleteRow: customConfirm,
    onRowClick: selectedValues,
    afterInsertRow: onAfterInsertRow,
  };

  function onAfterInsertRow(row) {
    let RequestDTO = {
      Description: row.description,
      IdUser: userInfo.userId,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/WebConfigurator/WebColumn_Insert",
      //url: 'https://localhost:44337/api/WebConfigurator/WebColumn_Insert',
      data: RequestDTO,
    }).then((response) => {
      if (response.data === 0) {
        GetColumn();
        alert("Data Successfully Inserted");
      }
      console.log("response", response);
    });
  }

  const cellEditProp = {
    mode: "click", //DBClick daba problemas con el Expand se cambio a click
    //beforeSaveCell: onBeforeSaveCell, // a hook for before saving cell
    afterSaveCell: onAfterSaveCell, // a hook for after saving cell
  };
  const selectRowProp = {
    mode: "checkbox",

    //clickToSelect: false, // enable click to select

    clickToSelect: true, // click to select, default is false
    clickToExpand: true, // click to expand row, default is false
    //onSelect: onRowSelect,
  };

  function onAfterSaveCell(row, cellName, cellValue) {
    let RequestDTO = {
      IdColumn: row.idColumn,
      Description: row.description,
      IdUser: userInfo.userId,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/WebConfigurator/WebColumn_Update",
      //url: 'https://localhost:44337/api/WebConfigurator/WebColumn_Update',
      data: RequestDTO,
    }).then((response) => {
      if (response.data === 0) {
        alert("Data Successfully Updated");
      }
      console.log("response", response);
    });
  }

  function onAfterDeleteRow(rowKeys) {
    let RequestDTO = {
      IdColumn: rowKeys[0],
      IdUser: userInfo.userId,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/WebConfigurator/WebColumn_Delete",
      //url: 'https://localhost:44337/api/WebConfigurator/WebColumn_Delete',
      data: RequestDTO,
    }).then((response) => {
      if (response.data === true) {
        alert("Data Successfully Deleted");
      }
    });
  }

  const handleIdWebChange = (event, newValue) => {
    console.log("Linetype", newValue.props.value);
    props.setWebOnMem(event.target.value, props.row);
    setSelectedIdWeb(newValue.props.value);
  };
  const printInputList = () => {
    return (
      <div>
        <FormControl
          className={`${classes.formControl} w-full`}
          size="small"
          variant="outlined"
        >
          <InputLabel shrink id="demo-simple-select-placeholder-label-label">
            Web Column
          </InputLabel>
          <Select
            labelId="demo-simple-select-placeholder-label-label"
            id="demo-simple-select-placeholder-label"
            value={selectedIdWeb}
            onChange={handleIdWebChange}
            displayEmpty
            className={classes.selectEmpty}
          >
            {webColumns &&
              webColumns.map((row) => (
                <MenuItem value={row.idColumn}>{row.description}</MenuItem>
              ))}
          </Select>
        </FormControl>
      </div>
    );
  };
  const printList = () => {
    return (
      <div id="main-div Web-list" class="Web-list">
        <Paper className={classes.root}>
          <h2>Web columns</h2>
          {options && console.log("WebList rendering typeof", typeof webRows)}

          {isLoading ? <Loader></Loader> : ""}
          <Table className={classes.table} aria-label="simple table">
            <TableBody className={showInfo ? "show-table" : "hide-table"}>
              {webColumns && (
                <div>
                  <BootstrapTable
                    pagination={true}
                    options={options}
                    cellEdit={cellEditProp} //DBClick daba problemas con el Expand
                    insertRow={true}
                    version="4"
                    data={webColumns}
                    selectRow={selectRowProp}
                    deleteRow={true}
                    columnClassName="td-web-rows"
                    // deleteRow={true}
                    hover
                  >
                    <TableHeaderColumn
                      dataField="idColumn"
                      hiddenOnInsert
                      hidden
                      isKey={true}
                      autoValue={true}
                    >
                      Player ID
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      filter={{ type: "TextFilter", delay: 1000 }}
                      dataField="description"
                      columnClassName="td-web-rows"
                    >
                      Description
                    </TableHeaderColumn>
                  </BootstrapTable>
                </div>
              )}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  };

  if (redirect) {
    let pushURL = "/Web/" + redirect.IdWeb;
    console.log("Web Info props redirect", redirect);
    props.setWeb(redirect);
    printList();
    setRedirect(null);
    return (
      <div>
        <Redirect
          to={{
            pathname: pushURL,
          }}
        />

        { }
      </div>
    );

    //history.push(pushURL);
  }

  if (props.isInput) {
    return printInputList();
  } else {
    return printList();
  }
}

export default WebList;
